<template>
  <BModal
    id="modal-failed-ticket"
    hide-footer
    hide-header
    centered
    size="lg"
  >
    <div class="text-black text-2xl font-semibold text-center my-2">
      Data Tiket Gagal
    </div>
    <BTable
      :items="itemsTicket"
      :fields="fieldsFailedTicket"
      show-empty
      empty-text="Tidak ada data yang ditampilkan."
      responsive
      sticky-header="320px"
    />
    <div class="w-full text-end px-2 my-2">
      <b-button
        variant="outline-primary"
        @click="$bvModal.hide('modal-failed-ticket')"
      >
        Tutup
      </b-button>
    </div>
  </BModal>
</template>

<script>
import { fieldsFailedTicket } from './config'

export default {
  props: {
    itemsTicket: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fieldsFailedTicket,
    }
  },
}
</script>
